/*
  BuildDirect — contextual in-article free-sample offer

  Measurement only. snippets/bd-sample-cta.liquid renders a plain anchor that
  works with this file blocked, missing or still loading; nothing here is
  required for the offer to be usable.

  It exists because the change this module is making is a number: the blog took
  6,697 sessions on one article and produced zero add-to-carts. "Did the module
  fix that" cannot be answered from session counts alone — a sample CTA that is
  never scrolled to and a sample CTA that is scrolled past are the same row in
  GA until one of them reports being seen. So two events:

    sample_cta_view   fired once, when at least half the card has been on
                      screen for a full second. Not on render: the module sits
                      a third of the way down the article and most of the page's
                      sessions never reach it, which is itself the finding.
    sample_cta_click  fired on the way out, from a pointerdown/keydown listener
                      rather than `click`, so it is recorded before the
                      navigation tears the page down.

  Both carry the category key ('vinyl', 'tile', 'generic', …) and the article
  handle, which is what turns this into the per-post table the blog needs:
  impressions, clicks and CTR by category and by article.

  The Shopify-side conversion is already tracked — the Order Sample button on
  the collection page is the store's own add-to-cart — so nothing here needs to
  follow the reader past the click.
*/
(function () {
  'use strict';

  /* One page can only carry one of these, but the Section Rendering API and the
     theme editor can both re-run this file against a live DOM. */
  if (window.__bdSampleCtaInit) return;
  window.__bdSampleCtaInit = true;

  var VIEW_DWELL_MS = 1000;
  var VIEW_RATIO = 0.5;

  function push(event, card, extra) {
    var data = {
      event: event,
      sample_cta_category: card.getAttribute('data-bd-sample-cta') || '',
      sample_cta_placement: card.getAttribute('data-bd-sample-cta-placement') || '',
      /* The article, so the report can be read per post rather than per
         category. Read from the DOM rather than printed into the markup by
         Liquid, so a cached section cannot carry a stale handle. */
      sample_cta_article: location.pathname
    };
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) data[k] = extra[k];
      }
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  function watch(card) {
    var link = card.querySelector('.bd-sample-cta__button');

    /* ------------------------------------------------------------- the click
       pointerdown and keydown, not click: a same-tab navigation can outrun a
       click handler, and this is the event the whole module is judged on. */
    if (link) {
      var sent = false;
      var fire = function () {
        if (sent) return;
        sent = true;
        push('sample_cta_click', card, {
          sample_cta_href: link.getAttribute('href') || '',
          sample_cta_external: card.classList.contains('bd-sample-cta--external')
        });
      };
      link.addEventListener('pointerdown', fire);
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') fire();
      });
      /* Mouse-less, pointer-less and keyboard-less paths (a script click, an
         assistive tool) still land here. */
      link.addEventListener('click', fire);
    }

    /* -------------------------------------------------------------- the view
       Half the card, for a full second. A card that flicks past during a fast
       scroll to the comments was not an impression. */
    if (!('IntersectionObserver' in window)) {
      push('sample_cta_view', card, { sample_cta_observed: false });
      return;
    }

    var timer = null;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (timer) return;
            timer = setTimeout(function () {
              push('sample_cta_view', card, { sample_cta_observed: true });
              observer.disconnect();
            }, VIEW_DWELL_MS);
          } else if (timer) {
            clearTimeout(timer);
            timer = null;
          }
        });
      },
      { threshold: VIEW_RATIO }
    );

    observer.observe(card);
  }

  function init() {
    document.querySelectorAll('[data-bd-sample-cta]').forEach(function (card) {
      if (card.__bdSampleCtaBound) return;
      card.__bdSampleCtaBound = true;
      watch(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
